import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/web/img_case_01.webp";
import Img2 from "../../../images/locationgcc/web/img_case_02.webp";
import Img3 from "../../../images/locationgcc/web/img_case_03.webp";

const CaseStudy = [
  {
    title: "Talpool",
    description: "Unleash Your Talent, Discover Opportunities",
    link: "talpool",
    Img: Img1,
    BgColor: "#6747C2",
    TextColor: "#FFFFFF",
  },
  {
    title: "Select",
    description: "Driving Dealership Success",
    link: "select-dealer",
    Img: Img2,
    BgColor: "#E46426",
    TextColor: "#FFFFFF",
  },
  {
    title: "Al Hussaini",
    description:
      "Al Hussaini Trading Company stands as a premier marketplace in Saudi Arabia, offering a wide range of watches, jewelry, leather goods, and writing instruments.",
    link: "alhussaini",
    Img: Img3,
    BgColor: "#885037",
    TextColor: "#FFFFFF",
  },
];

const StoriesCase = () => {
  return (
    <div className="case_section">
      <Container className="h-100">
        <Row className="h-100">
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    View Full Casestudy
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoriesCase;
